import { InputMask } from "@react-input/mask";
import { formatPhoneNumber } from "@utils";
import { useEffect, useState } from "react";

import TooltipUI from "../../TooltipUI";

import "./style.scss";

const AB_3422 = ({
    inputPhoneRef,
    sendPhone,
    setSendPhone,
    setCodeValue,
    codeValue,
    inputFieldsState,
    error,
    maskType,
    placeholder,
    handlePhone,
    handleClick,
    errorCode,
    setErrorCode,
    smsProviderType,
    setSmsType,
    shouldStopRef,
    setLoaderBtn,
    className = "",
    id,
    setTriggerIcon = () => {},
    icon,
    setInputFieldsState = () => {},
    autoFocus = false,
}) => {
    const [focus, setFocus] = useState();
    const [timer, setTimer] = useState(59000);
    const [tooManyReq, setTooManyReq] = useState(false);

    useEffect(() => {
        if (smsProviderType === "pushMts") {
            setTimer(59000 * 2);
        }
    }, [smsProviderType]);

    useEffect(() => {
        if (sendPhone) {
            const intervalId = setTimeout(() => {
                if (timer > 0) {
                    setTimer(timer - 1000);
                } else {
                    clearTimeout(intervalId);
                }
            }, 1000);

            return () => {
                clearTimeout(intervalId);
            };
        }
    }, [sendPhone, timer]);

    const handleCode = (e) => {
        e.persist();

        let val = e.target.value;

        setCodeValue((prev) => {
            let obj = { ...prev, [e.target.id]: val.slice(-1) };
            return obj;
        });
        let id = val == "" ? Number(e.target.id) : Number(e.target.id) + 1;
        let inp = document.getElementById(id);
        if (inp) inp.focus();
    };

    const onKeyDown = (e) => {
        let val = e.target.value;

        if (e.keyCode == 8) {
            let id = val !== "" ? Number(e.target.id) : Number(e.target.id) - 1;
            let inp = document.getElementById(id);
            setCodeValue((prev) => {
                let obj = { ...prev, [e.target.id]: "" };
                return obj;
            });

            if (inp) inp.focus();
        }
    };

    const pasteHandler = () => {
        navigator.clipboard
            .readText()
            .then((text) => {
                if (text && text.length == 6) {
                    const initObj = {
                        0: "",
                        1: "",
                        2: "",
                        3: "",
                    };
                    const newObj = text.split("").reduce((acc, val, index) => {
                        acc[index] = val;
                        return acc;
                    }, initObj);
                    setCodeValue(newObj);
                }
            })
            .catch((err) => {
                console.log("Что-то пошло не так", err);
            });
    };

    const inputsItems = [0, 1, 2, 3].map((idx) => {
        return (
            <input
                placeholder={focus === idx ? "" : "_"}
                type="number"
                value={codeValue[idx].toLocaleString()}
                onChange={handleCode}
                onKeyDown={onKeyDown}
                onPaste={pasteHandler}
                onFocus={() => {
                    setFocus(idx);
                    setErrorCode(false);
                }}
                onBlur={() => setFocus(false)}
                className={`body_regular form__number-input-item  ${errorCode ? "error" : ""} ${className}`}
                minLength={1}
                maxLength={1}
                min={1}
                max={1}
                key={idx}
                id={idx}
            />
        );
    });

    const sec = (ms) => {
        ms = Math.max(0, ms);
        const totalSeconds = Math.floor(ms / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        const formattedMinutes = String(minutes).padStart(2, "0");
        const formattedSeconds = String(seconds).padStart(2, "0");

        return `${formattedMinutes}:${formattedSeconds}`;
    };

    const onClickChangPhone = () => {
        setCodeValue({
            0: "",
            1: "",
            2: "",
            3: "",
        });
        setSendPhone(false);
    };

    const renderVerifyBlock = () => {
        const cfg = providerConfig[smsProviderType || "smsMts"];
        if (!cfg) return null;

        return (
            <div className={`ab-3422 call-window ${className}`}>
                <div className="call-window__block">
                    <span className="call-window__title">{cfg.title}</span>
                    <span className="call-window__phone">{formatPhoneNumber(inputFieldsState.phone, true)}</span>

                    <div
                        className="call-window__change-phone-btn"
                        onClick={() => {
                            if (smsProviderType === "pushMts") {
                                setTimer(59000 * 2);
                            } else {
                                setTimer(59000);
                            }
                            onClickChangPhone();
                            setTooManyReq(false);
                            shouldStopRef.current = false;
                            setLoaderBtn(false);
                            setTriggerIcon((prev) => {
                                return { ...prev, phone: 1 };
                            });
                        }}
                    >
                        Исправить номер
                    </div>
                </div>

                <span className="call-window__text">{cfg.text}</span>
                <div className={`form-number-input ${error ? "error" : ""}`}>{inputsItems}</div>
                {errorCode ? <span className="error">{errorCode}</span> : null}

                <span className="call-window__recall-desc">
                    {tooManyReq ? (
                        cfg.extra || "Превышен лимит запросов"
                    ) : timer > 0 ? (
                        cfg.repeat(sec(timer))
                    ) : (
                        <div
                            className="call-window__recall-button"
                            onClick={() => {
                                setCodeValue({ 0: "", 1: "", 2: "", 3: "" });
                                document.querySelector(".form__number-input")?.classList.remove("error");
                                setTimer(59000);
                                setTooManyReq(true);
                                shouldStopRef.current = false;
                                setLoaderBtn(true);
                                handleClick(true);
                            }}
                        >
                            {cfg.repeatBtn}
                        </div>
                    )}
                </span>
            </div>
        );
    };

    return (
        <>
            {sendPhone ? (
                renderVerifyBlock()
            ) : (
                <div className={`ab-3422 form-input-phone ${error ? "error" : ""}  ${inputFieldsState.phone.length > 10 ? "filled" : ""} ${className}`}>
                    <InputMask
                        autocomplete="new-password"
                        ref={inputPhoneRef}
                        onChange={handlePhone}
                        mask={maskType}
                        autoFocus={autoFocus}
                        showMask
                        replacement={{ _: /\d/ }}
                        placeholder={placeholder}
                        className={`input_phone ${inputFieldsState.phone?.length > 1 ? "" : "empty"}`}
                        id="phones"
                        onFocus={(e) => {
                            if (e.target.value.replace(/\D/gim, "").length > 1 && e.target.value.replace(/\D/gim, "").length !== 11) {
                                setTriggerIcon((prev) => {
                                    return { ...prev, [id]: 2 };
                                });
                            }
                            if (e.target.value.replace(/\D/gim, "").length === 1) {
                                setTriggerIcon((prev) => {
                                    return { ...prev, [id]: 1 };
                                });
                            }
                        }}
                        onBlur={(e) => {
                            if (e.target.value.replace(/\D/gim, "").length == 11) {
                                setTriggerIcon((prev) => {
                                    return { ...prev, [id]: 3 };
                                });
                            }
                            if (e.target.value.replace(/\D/gim, "").length > 1 && e.target.value.replace(/\D/gim, "").length !== 11) {
                                setTriggerIcon((prev) => {
                                    return { ...prev, [id]: 2 };
                                });
                            }
                            if (e.target.value.replace(/\D/gim, "").length == 1) {
                                setTriggerIcon((prev) => {
                                    return { ...prev, [id]: 0 };
                                });
                            }
                        }}
                    />
                    {icon && inputFieldsState.phone?.length > 1 ? (
                        <img
                            src={icon}
                            className="default__icon"
                            onClick={() => {
                                setInputFieldsState((prev) => {
                                    return { ...prev, phone: false };
                                });
                                setTriggerIcon((prev) => {
                                    return { ...prev, [id]: 0 };
                                });
                                inputPhoneRef.current.value = "+7 (___) ___-__-__";
                            }}
                        />
                    ) : null}
                </div>
            )}
        </>
    );
};

const providerConfig = {
    smsMts: {
        title: "Мы отправили вам СМС на номер",
        text: "Введите код, который вам пришел",
        repeat: (sec) => `Повторный запрос через ${sec}`,
        repeatBtn: "Повторный запрос",
        extra: (
            <>
                <TooltipUI
                    style={{ maxWidth: "232px", textAlign: "center", padding: "10.5px" }}
                    pt={{ text: { style: { fontSize: "10px", fontWeight: 400, lineHeight: "12px" } } }}
                    target=".call-window__notcome"
                    position="bottom"
                    content="Не удалось подтвердить ваш телефон. Проверьте&nbsp;номер и интернет-соединение и&nbsp;попробуйте ещё раз. Если не получится — выберите другой подарок."
                />
                <div className="call-window__notcome">
                    <i />
                    <span>Не смогли доставить код</span>
                </div>
            </>
        ),
    },

    smsMtsRepeat: {
        title: "Мы позвоним вам на номер",
        text: "Примите звонок и введите код, который вам продиктует наш автоматический помощник",
        repeat: (sec) => `Повторный запрос через ${sec}`,
        repeatBtn: "Повторный запрос",
        extra: (
            <>
                <TooltipUI
                    style={{ maxWidth: "232px", textAlign: "center", padding: "10.5px" }}
                    pt={{ text: { style: { fontSize: "10px", fontWeight: 400, lineHeight: "12px" } } }}
                    target=".call-window__notcome"
                    position="bottom"
                    content="Не удалось подтвердить ваш телефон. Проверьте&nbsp;номер и интернет-соединение и&nbsp;попробуйте ещё раз. Если не получится — выберите другой подарок."
                />
                <div className="call-window__notcome">
                    <i />
                    <span>Не смогли доставить код</span>
                </div>
            </>
        ),
    },
    smsProsto: {
        title: "Мы позвоним вам на номер",
        text: (
            <>
                Введите код, который вам продиктует <br /> наш автоматический помощник
            </>
        ),
        repeat: (sec) => `Повторный звонок через ${sec}`,
        repeatBtn: "Повторный звонок",
        extra: (
            <>
                <TooltipUI
                    style={{ maxWidth: "232px", textAlign: "center", padding: "10.5px" }}
                    pt={{ text: { style: { fontSize: "10px", fontWeight: 400, lineHeight: "12px" } } }}
                    target=".call-window__notcome"
                    position="bottom"
                    content="Не удалось подтвердить ваш телефон. Проверьте&nbsp;номер и интернет-соединение и&nbsp;попробуйте ещё раз. Если не получится — выберите другой подарок."
                />
                <div className="call-window__notcome">
                    <i />
                    <span>Телефон не подтвержден</span>
                </div>
            </>
        ),
    },

    pushMts: {
        title: "Подтвердите вход на телефоне, чтобы получить подарок, либо дождитесь смс.",

        repeat: (sec) => `Повторный запрос через ${sec}`,
        repeatBtn: "Повторный запрос",
        // noCode: true,
    },
    smsProsto2: {
        title: "Мы отправили вам СМС на номер",
        text: "Введите код, который вам пришел",
        repeat: (sec) => `Повторный звонок через ${sec}`,
        repeatBtn: "Повторный звонок",
    },
};

export default AB_3422;
